module.exports = __webpack_public_path__ + "static/media/Globe.e2e22777.png";